import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import _ from 'lodash'
import { Dimmer, Loader, Table, Label, Button, Statistic, Segment, Checkbox } from 'semantic-ui-react'
import ReportModal from '../../components/invoice/ReportModal'

import RestaurantActions from '../../reducers/restaurantReducer'
import HasuraOrderActions from '../../reducers/hasuraOrderReducer'
import utils from '../../utils'

import FilterField from '../../components/reports/fields/dateRangeSearchField'

import DownloadButton from './components/ReportMerchantDownloadButton'
import timeFromNow from './components/TimeFromNow'

class MerchantReport extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      merchantKey: null,
      branchKey: null,
      displayRejected: true,
      activeOrderKey: null,
      modalReportVisible: false,

      startFrom: Number(
        moment()
          .startOf('day')
          .format('x')
      ),
      endAt: Number(
        moment()
          .endOf('day')
          .format('x')
      ),
    }
  }

  componentDidMount() {
    const { startFrom, endAt, fetchMerchants, merchantsLoaded } = this.props

    if (startFrom && endAt) {
      this.setState({
        startFrom: moment(startFrom),
        endAt: moment(endAt),
      })
    }

    if (!merchantsLoaded) {
      fetchMerchants()
    }
  }

  getFilteredOrders = () => {
    const { orders } = this.props
    const { branchKey, merchantKey, displayRejected } = this.state

    const merchantOrders = []
    const orderCount = orders.length

    for (let i = 0; i < orderCount; i += 1) {
      const order = orders[i]
      const isCurrentMerchantOrder = order.merchant_key === merchantKey
      const isCurrentBranchOrder = branchKey ? order.branch_key === branchKey : true

      if (!displayRejected && order.status === 'rejected') {
        continue
      }
      if (isCurrentBranchOrder && isCurrentMerchantOrder) {
        merchantOrders.push({ ...order, key: order.firebase_key })
      }
    }
    return merchantOrders
  }

  validateSearchByDate = () => {
    const { startFrom, endAt, merchantKey } = this.state

    if (startFrom > endAt || !merchantKey) {
      return false
    }

    return true
  }

  getOrderByDate = () => {
    const { startFrom, endAt, merchantKey } = this.state
    const { fetchOrders } = this.props
    fetchOrders(merchantKey, startFrom, endAt, [])
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  onSearch = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.getOrderByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  onAllButtonClick = () => {
    this.setState({ branchKey: null })
  }

  onBranchButtonClick = branchKey => {
    this.setState({ branchKey })
  }

  renderStatusLabel = status => (
    <Label color={utils.helpers.getOrderStatus(status).color} style={{ margin: 0, marginBottom: 5 }}>
      {utils.helpers.getOrderStatus(status).label}
    </Label>
  )

  renderTimeStampCell = timeStamp => (
    <Table.Cell textAlign="center">
      <span style={{ color: 'rgba(208, 62, 62, 1)' }}>{moment(timeStamp).fromNow()}</span>
      <br />
      {moment(timeStamp).format('HH:mm a')}
      <br />
      {moment(timeStamp).format('DD-MMM-YYYY')}
      <br />
    </Table.Cell>
  )

  renderOrdersTable = orders => {
    const sortedOrders = _.sortBy(orders, 'created_at')
    return (
      <Table fixed basic style={{ marginTop: 0 }}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Order Number</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Branch</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Total</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Ordered At</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Updated At</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">State</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {sortedOrders.length > 0
            ? sortedOrders.map(order => {
                return this.tableRowWithPopup(order)
              })
            : this.renderNoDataRow()}
        </Table.Body>
      </Table>
    )
  }

  tableRowWithPopup = order => {
    const { activeOrderKey } = this.state
    const {
      firebase_key: orderKey,
      customer_tel: customerTel,
      branch_name: branchName,
      created_at: createdAt,
      updated_at: updatedAt,
      status,
      subtotal,
    } = order
    return (
      <Table.Row key={orderKey} active={orderKey === activeOrderKey}>
        <Table.Cell>
          {(order ? utils.order.getOrderNumber({ key: orderKey, tel: customerTel }) : '').toUpperCase()}
        </Table.Cell>
        <Table.Cell textAlign="center">{branchName}</Table.Cell>
        <Table.Cell textAlign="center">{utils.helpers.convertToCurrency(subtotal)}</Table.Cell>
        <Table.Cell textAlign="center">{timeFromNow(createdAt)}</Table.Cell>
        <Table.Cell textAlign="center">{timeFromNow(updatedAt)}</Table.Cell>
        <Table.Cell textAlign="center">{this.renderStatusLabel(status)}</Table.Cell>
      </Table.Row>
    )
  }

  renderNoDataRow = () => {
    return (
      <Table.Row>
        <Table.Cell colSpan={6} textAlign="center">
          No Data available
        </Table.Cell>
      </Table.Row>
    )
  }

  renderLoading = () => {
    return (
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer>
    )
  }

  getDisplayMerchants = () => {
    const { merchants } = this.props
    const merchKeys = Object.keys(merchants)
    const displayMerchants = []

    for (let i = 0; i < merchKeys.length; i += 1) {
      const merchKey = merchKeys[i]
      const merch = merchants[merchKey]
      const isArchived = merch.status === 'archived'
      // const isDraft = merch.status === 'draft'

      if (!isArchived) {
        displayMerchants.push({
          key: merchKey,
          text: merch.name,
          value: merchKey,
        })
      }
    }

    return displayMerchants
  }

  renderStatistics = orders => {
    const orderCount = orders.length

    let successOrderCount = 0
    let rejectedOrderCount = 0
    let allSubtotal = 0
    let commission = 0
    let promotionDiscount = 0
    let promoCodeDiscount = 0
    let commissionVat = 0

    for (let i = 0; i < orderCount; i += 1) {
      const order = orders[i]
      const { status } = order
      if (status === 'delivered') {
        const {
          promotion_discount: merchantDiscount,
          voucher_discount_amount: voucherDiscount,
          merchant_commission_rate: merchantCommissionRate,
          subtotal,
        } = order
        successOrderCount += 1
        allSubtotal += subtotal
        commission += subtotal * (merchantCommissionRate / 100)
        promotionDiscount += merchantDiscount
        promoCodeDiscount += voucherDiscount
      } else if (status === 'rejected') {
        rejectedOrderCount += 1
      }
    }

    const orderItems = [
      {
        key: 'orders',
        label: 'Orders',
        value: orderCount,
      },
      {
        key: 'success-orders',
        label: 'Success Orders',
        value: successOrderCount,
        color: 'green',
      },
      {
        key: 'rejected-orders',
        label: 'Rejected Orders',
        value: rejectedOrderCount,
        color: 'red',
      },
    ]

    commissionVat = commission * 0.1

    const paymentItems = [
      {
        key: 'subtotal',
        label: 'Sub-Total',
        value: utils.helpers.convertToCurrency(allSubtotal),
      },
      {
        key: 'commission',
        label: 'Commission',
        value: utils.helpers.convertToCurrency(commission),
      },
      {
        key: 'vat-on-commission',
        label: 'VAT on Commission',
        value: utils.helpers.convertToCurrency(commissionVat),
      },
      {
        key: 'promotion',
        label: 'Promotion Discount',
        value: utils.helpers.convertToCurrency(promotionDiscount),
      },
      {
        key: 'promo-code',
        label: 'Promo Code',
        value: utils.helpers.convertToCurrency(promoCodeDiscount),
      },
    ]

    return (
      <div style={{ marginBottom: 14 }}>
        <Segment>
          <Statistic.Group items={orderItems} widths="three" size="small" />
        </Segment>
        <Segment>
          <Statistic.Group items={paymentItems} widths="five" size="small" />
        </Segment>
      </div>
    )
  }

  renderBranchSelectButtons = () => {
    const { branchKey, merchantKey } = this.state
    const { merchants } = this.props

    if (!merchantKey) {
      return null
    }

    const branches = merchants[merchantKey].branches || {}

    if (_.size(branches) > 1) {
      return (
        <div style={{ marginTop: 14 }}>
          <Button as="a" onClick={this.onAllButtonClick} basic={!!branchKey}>
            All
          </Button>
          {_.map(branches, (branch, key) => (
            <Button
              key={key}
              as="a"
              style={{ marginBottom: 6 }}
              onClick={() => this.onBranchButtonClick(key)}
              basic={branchKey !== key}
            >
              {branch.name}
            </Button>
          ))}
        </div>
      )
    }

    return null
  }

  renderStateFilterButtons = () => {
    const { displayRejected } = this.state
    return (
      <div style={{ marginTop: 14, marginBottom: 14 }}>
        <Checkbox
          label="Display Rejected"
          checked={displayRejected}
          onChange={(e, { checked }) => {
            this.setState({ displayRejected: checked })
          }}
        />
      </div>
    )
  }

  renderReportModal = () => {
    const { startFrom, endAt, modalReportVisible, merchantKey } = this.state
    const { merchants, orders } = this.props
    const allOrders = _.reduce(
      orders,
      (accum, order) => {
        const { status, subtotal, branch_key, branch_name, merchant_name } = order
        if (status === 'delivered') {
          accum.push({
            subtotal,
            branchId: branch_key,
            branchName: branch_name,
            merchantName: merchant_name,
          })
        }
        return accum
      },
      []
    )
    return (
      <ReportModal
        startFrom={startFrom}
        endAt={endAt}
        orders={allOrders}
        modalReportVisible={modalReportVisible}
        merchant={merchants[merchantKey]}
        onFieldChange={this.onFieldChange}
      />
    )
  }

  renderContent = () => {
    const { startFrom, endAt, modalReportVisible, merchantKey, branchKey } = this.state
    const { merchantsLoading, merchants, ordersLoading } = this.props
    const merchantSelect = this.getDisplayMerchants()
    const orders = this.getFilteredOrders()
    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <FilterField
            loading={merchantsLoading}
            startFrom={startFrom}
            endAt={endAt}
            merchants={merchantSelect}
            merchantKey={merchantKey}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />
          {this.renderBranchSelectButtons()}
          {this.renderStateFilterButtons()}
          <Button onClick={() => this.setState({ modalReportVisible: !modalReportVisible })}>Invoice</Button>
          <DownloadButton
            merchant={merchants[merchantKey]}
            branchKey={branchKey}
            startFrom={startFrom}
            endAt={endAt}
            orderIds={orders.map(o => o.firebase_key)}
          />
        </div>
        <div
          style={{
            padding: '14px 14px 0px 14px',
          }}
          className="list-content"
        >
          {this.renderStatistics(orders)}
          {ordersLoading ? this.renderLoading() : this.renderOrdersTable(orders)}
        </div>
        {merchantKey && orders.length > 0 && this.renderReportModal()}
      </Segment>
    )
  }

  render() {
    return this.renderContent()
  }
}

const mapState = ({ hasuraOrders, restaurants }) => ({
  orders: hasuraOrders.orders,
  ordersLoading: hasuraOrders.loading,
  merchants: restaurants.data,
  merchantsLoaded: restaurants.loaded,
  merchantsLoading: restaurants.loading,
})

const mapDispatch = {
  fetchOrders: HasuraOrderActions.fetchOrders,
  fetchOrder: HasuraOrderActions.fetchOrder,
  fetchMerchants: RestaurantActions.fetchRestaurantsRequest,
}

export default connect(
  mapState,
  mapDispatch
)(MerchantReport)



// WEBPACK FOOTER //
// ./src/containers/reports/merchant.js